import React from 'react';
import { View } from 'react-native';
import { BorderRadiusTokens, ButtonTypeTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InfoStateTokens, InfoTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Icon from '../icon/Icon';
import Button from '../button/Button';
const Info = ({ label, message, borderRadius = BorderRadiusTokens.BR2, bgColor = ColorTokens.Grey_Milk_1, 
//labelColor = ColorTokens.Grey_Charcoal,
padding = SizeTypeTokens.SM, actionText, onPress, type = InfoTypeTokens.SUCCESS, state = InfoStateTokens.GRADIENT, actionIcon = {
    name: IconTokens.ChervonDownRight,
    size: IconSizeTokens.XXS,
}, }) => {
    const theme = ThemeProvider.getTheme();
    const handleAction = () => {
        onPress && onPress();
    };
    const bgColorValue = theme.colors[bgColor];
    //const labelColorValue = theme.colors[labelColor];
    const paddingValue = theme.paddingSize[padding];
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const viewStyleProps = React.useMemo(() => ({
        borderRadius: borderRadiusValue,
        padding: paddingValue,
        backgroundColor: bgColorValue,
    }), [borderRadiusValue, paddingValue, bgColorValue]);
    return (React.createElement(View, { style: [viewStyleProps, { padding: 12 }] },
        React.createElement(View, { style: { flex: 1, width: '100%' } },
            React.createElement(View, { style: { flex: 1 } },
                React.createElement(Typography, { label: label, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Night }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { label: message, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                actionText ? (React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, labelColor: ColorTokens.Primary_100, label: actionText, icon: actionIcon, onPress: handleAction })) : (React.createElement(React.Fragment, null)),
                state === 'GRADIENT' ? (React.createElement(View, { style: {
                        position: 'absolute',
                        bottom: -12,
                        right: -12,
                    } },
                    React.createElement(Icon, { name: IconTokens.InfoCropped, size: IconSizeTokens.XXXXXXXL, color: ColorTokens.Grey_Smoke }))) : (React.createElement(React.Fragment, null))))));
};
export default React.memo(Info);
export { Info };
